import clsx from 'clsx'
import { useAppDispatch } from '../../../lib/redux/hook'
import { TickIcon } from '../../../ui/icons/tickIcon'
import '../style.css'

export function SuccesfulPayment() {

    return (
        <div className={'flex  min-w-fit relative   justify-center'}>
            <div className=' background h-screen rounded-r-[40px] w-[60%] bg-[#170264] flex justify-center items-center'>
            </div>
            <div className={clsx(' basis-[40%] flex flex-col flex-grow items-center gap-10', {
                'justify-center h-screen': (window.location.pathname === '/success')
            })}>
                <div className=' bg-green-500 rounded-full flex justify-center items-center gap-2 p-4'>
                    <TickIcon color='white' size='32' />
                </div>
                <h1 className='font-bold text-heading-xl w-[80%] text-center text-neutral-850 '>🎉 {'Operazione completata con successo!'}</h1>
            </div>
        </div>
    )
}
